
import Swiper from "swiper/bundle";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import { __ } from '@wordpress/i18n';

const getTranslatedString = (key, fallback) => {
    if (window.douzeI18n && typeof window.douzeI18n[key] === 'string' && window.douzeI18n[key]) {
        return window.douzeI18n[key];
    }

    return __(fallback, 'douze-cycles');
};

const wcSingleProduct = {
    originalVariationPrice: 0, // Stockage global du prix original

    readyFn: function () {
        let self = this;
        self.initImageGallery();
        self.initVariationsScroll();
        self.initCustomAttributes();
        self.initImageTransitions();
        self.initRelatedProductsSearch();
        self.initOptionalProducts();
        self.initHelpTooltip();
        self.initMobileDescriptionToggle();
        // Attendre que WooCommerce soit prêt
        setTimeout(() => {
            self.setDefaultAttributes();
        }, 100);

        // Stocker les valeurs originales de l'image principale
        const mainImageContainer = document.querySelector('.main-image');
        if (mainImageContainer) {
            const img = mainImageContainer.querySelector('img');
            if (img) {
                img.dataset.originalSrc = img.src;
                img.dataset.originalSrcset = img.srcset || '';
                img.dataset.originalSizes = img.sizes || '';
                img.dataset.originalAlt = img.alt || '';
            }
        }
    },

    initImageGallery: function () {
        const swiperThumbnails = new Swiper('.swiper-thumbnails', {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 4,
            // freeMode: true,
            // watchSlidesProgress: true,
            centeredSlides: false,
            watchOverflow: true,
            enabled: true
        });
        const swiperMain = new Swiper('.swiper-main', {
            // modules: [Navigation, Thumbs],
            loop: true,
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: swiperThumbnails,
            },
        });
        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });
    },

    initVariationsScroll: function () {
        const scrollables = document.querySelectorAll('.variations-scrollable');
        scrollables.forEach(scrollable => {
            this.setupScrollable(scrollable);
        });
    },

    setupScrollable: function (scrollable) {
        if (!scrollable || scrollable.classList.contains('is-initialized')) return;
        scrollable.classList.add('is-initialized');

        // Apply necessary styles dynamically
        scrollable.style.overflowX = 'auto';
        scrollable.style.scrollBehavior = 'smooth';
        // Hide scrollbar for a cleaner custom UI
        scrollable.style.scrollbarWidth = 'none'; // Firefox
        scrollable.style.msOverflowStyle = 'none'; // IE/Edge
        // For Webkit, we'd need CSS ::-webkit-scrollbar { display: none; } which we can't do easily in JS inline styles on the element

        const container = scrollable.closest('.config-frame');
        const prevBtn = container ? container.querySelector('.nav-left') : null;
        const nextBtn = container ? container.querySelector('.nav-right') : null;

        const checkArrows = () => {
            // S'il n'y a pas de boutons, on ignore la logique des flèches mais on garde le drag
            if (!prevBtn || !nextBtn) return;

            const maxScroll = scrollable.scrollWidth - scrollable.clientWidth;
            const tolerance = 2;

            if (maxScroll <= 0) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
                return;
            }

            // Ensure buttons are accessible
            prevBtn.style.display = 'block';
            nextBtn.style.display = 'block';

            // Using visibility to keep layout stable to prevent arrows from jumping when one disappears
            prevBtn.style.visibility = scrollable.scrollLeft > tolerance ? 'visible' : 'hidden';
            nextBtn.style.visibility = scrollable.scrollLeft < maxScroll - tolerance ? 'visible' : 'hidden';
        };

        checkArrows();
        window.addEventListener('resize', checkArrows);
        scrollable.addEventListener('scroll', checkArrows);

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                scrollable.scrollBy({
                    left: -300,
                    behavior: 'smooth'
                });
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                scrollable.scrollBy({
                    left: 300,
                    behavior: 'smooth'
                });
            });
        }

        // Drag to scroll implementation for desktop
        let isDown = false;
        let startX;
        let scrollLeft;

        scrollable.style.cursor = 'grab';
        scrollable.style.userSelect = 'none';

        scrollable.addEventListener('mousedown', (e) => {
            isDown = true;
            scrollable.classList.add('active');
            startX = e.pageX - scrollable.offsetLeft;
            scrollLeft = scrollable.scrollLeft;
            scrollable.style.cursor = 'grabbing';
            // Disable scroll snap during drag if used
            scrollable.style.scrollBehavior = 'auto'; 
        });

        scrollable.addEventListener('mouseleave', () => {
            isDown = false;
            scrollable.classList.remove('active');
            scrollable.style.cursor = 'grab';
            scrollable.style.scrollBehavior = 'smooth';
        });

        scrollable.addEventListener('mouseup', () => {
            isDown = false;
            scrollable.classList.remove('active');
            scrollable.style.cursor = 'grab';
            scrollable.style.scrollBehavior = 'smooth';
        });

        scrollable.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollable.offsetLeft;
            const walk = (x - startX) * 2; // Scroll speed multiplier
            scrollable.scrollLeft = scrollLeft - walk;
        });
    },

    initCustomAttributes: function () {
        // Pour les pastilles de couleur
        document.addEventListener('change', function (e) {
            if (e.target.matches('.color-swatches-wrapper input[type="radio"]')) {
                const radio = e.target;
                const wrapper = radio.closest('.color-swatches-wrapper');
                const select = wrapper.nextElementSibling;

                select.value = radio.value;
                wrapper.querySelectorAll('.color-swatch').forEach(el => el.classList.remove('selected'));
                radio.closest('.color-swatch').classList.add('selected');

                // Déclencher l'événement WooCommerce
                if (typeof jQuery !== 'undefined') {
                    jQuery(select).trigger('change');
                }
            }
        });

        // Pour les radios d'attributs texte
        document.addEventListener('change', function (e) {
            if (e.target.matches('.attribute-radio-wrapper input[type="radio"]')) {
                const radio = e.target;
                const wrapper = radio.closest('.attribute-radio-wrapper');
                const select = wrapper.nextElementSibling;

                select.value = radio.value;
                wrapper.querySelectorAll('.attribute-radio').forEach(el => el.classList.remove('selected'));
                radio.closest('.attribute-radio').classList.add('selected');

                // Déclencher l'événement WooCommerce
                if (typeof jQuery !== 'undefined') {
                    jQuery(select).trigger('change');
                }
            }
        });

        // Pour les attributs avec images
        document.addEventListener('change', function (e) {
            if (e.target.matches('.attribute-image-wrapper input[type="radio"]')) {
                const radio = e.target;
                const wrapper = radio.closest('.attribute-image-wrapper');
                const select = wrapper.nextElementSibling;

                select.value = radio.value;
                wrapper.querySelectorAll('.attribute-image').forEach(el => el.classList.remove('selected'));
                radio.closest('.attribute-image').classList.add('selected');

                // Déclencher l'événement WooCommerce
                if (typeof jQuery !== 'undefined') {
                    jQuery(select).trigger('change');
                }
            }
        });

        // Réinitialiser lors du reset du formulaire
        document.addEventListener('click', function (e) {
            if (e.target.matches('.reset_variations')) {
                document.querySelectorAll('.color-swatches-wrapper input[type="radio"], .attribute-radio-wrapper input[type="radio"], .attribute-image-wrapper input[type="radio"]').forEach(input => {
                    input.checked = false;
                });
                document.querySelectorAll('.color-swatches-wrapper .color-swatch, .attribute-radio-wrapper .attribute-radio, .attribute-image-wrapper .attribute-image').forEach(el => {
                    el.classList.remove('selected');
                });
            }
        });
    },

    setDefaultAttributes: function () {
        // Les radios avec checked="checked" sont déjà sélectionnés par le PHP
        // Il faut juste s'assurer que les classes CSS sont cohérentes
        document.querySelectorAll('.color-swatches-wrapper input[checked], .attribute-radio-wrapper input[checked], .attribute-image-wrapper input[checked]').forEach(radio => {
            const wrapper = radio.closest('[class*="-wrapper"]');

            if (wrapper.classList.contains('color-swatches-wrapper')) {
                radio.closest('.color-swatch').classList.add('selected');
            } else if (wrapper.classList.contains('attribute-radio-wrapper')) {
                radio.closest('.attribute-radio').classList.add('selected');
            } else if (wrapper.classList.contains('attribute-image-wrapper')) {
                radio.closest('.attribute-image').classList.add('selected');
            }
        });

        // Déclencher la vérification des variations WooCommerce
        if (typeof jQuery !== 'undefined') {
            const form = jQuery('.variations_form');
            if (form.length) {
                form.trigger('wc_variation_form');
            }
        }
    },

    initImageTransitions: function () {
        // Observer les changements d'image de la galerie
        const gallery = document.querySelector('.product-gallery__wrapper');
        if (gallery) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList' || mutation.type === 'attributes') {
                        // Une image a changé, déclencher l'effet de transition
                        this.triggerImageTransition();
                    }
                });
            });

            observer.observe(gallery, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['src', 'srcset']
            });
        }

        // Écouter les événements de changement de variation WooCommerce
        if (typeof jQuery !== 'undefined') {
            jQuery(document).on('found_variation reset_image', '.variations_form', () => {
                this.triggerImageTransition();
            });

            // Met à jour l'image principale lors du changement de variation
            jQuery(document).on('found_variation', '.variations_form', (event, variation) => {
                // Cible l'image principale dans ta galerie custom
                const mainImageContainer = document.querySelector('.main-image');
                if (mainImageContainer && variation && variation.image && variation.image.src) {
                    const img = mainImageContainer.querySelector('img');
                    if (img) {
                        img.src = variation.image.src;
                        if (variation.image.srcset) {
                            img.srcset = variation.image.srcset;
                        }
                        if (variation.image.sizes) {
                            img.sizes = variation.image.sizes;
                        }
                        if (variation.image.alt) {
                            img.alt = variation.image.alt;
                        }
                    }
                }
                this.triggerImageTransition();
            });

            // Remet l'image principale d'origine lors du reset
            jQuery(document).on('reset_image', '.variations_form', () => {
                const mainImageContainer = document.querySelector('.main-image');
                if (mainImageContainer) {
                    const img = mainImageContainer.querySelector('img');
                    if (img && img.dataset && img.dataset.originalSrc) {
                        img.src = img.dataset.originalSrc;
                        if (img.dataset.originalSrcset) {
                            img.srcset = img.dataset.originalSrcset;
                        }
                        if (img.dataset.originalSizes) {
                            img.sizes = img.dataset.originalSizes;
                        }
                        if (img.dataset.originalAlt) {
                            img.alt = img.dataset.originalAlt;
                        }
                    }
                }
                this.triggerImageTransition();
            });
        }
    },

    triggerImageTransition: function () {
        const overlay = document.querySelector('.image-transition-overlay');
        const gallery = document.querySelector('.product-gallery__wrapper');

        if (overlay && gallery) {
            // Afficher l'overlay
            overlay.style.opacity = '0.7';

            // Masquer l'overlay après un court délai pour créer l'effet de fondu
            setTimeout(() => {
                overlay.style.opacity = '0';
            }, 200);
        }
    },

    initRelatedProductsSearch: function () {
        if (typeof jQuery !== 'undefined') {
            // Écouter les événements de variation trouvée
            jQuery(document).on('found_variation', '.variations_form', (event, variation) => {
                // Stocker le prix de la variation
                this.originalVariationPrice = parseFloat(variation.display_price) || 0;

                // Supprimer l'overlay de l'image du PO lors du changement de variation
                this.removeFullBikeOverlay();

                // Mettre à jour le prix (zone principale ET barre mobile)
                this.updateVariationPrice();

                this.searchRelatedProducts(variation.variation_id);
                this.updateConfigurationSummary(variation.variation_id);
            });

            // Écouter les événements de reset/hide variation
            jQuery(document).on('hide_variation', '.variations_form', () => {
                // Reset du prix original
                this.originalVariationPrice = 0;

                // Supprimer l'overlay de l'image du PO
                this.removeFullBikeOverlay();

                // Masquer les produits optionnels et décocher toutes les options
                const container = document.querySelector('.optional-products-container');
                if (container) {
                    container.innerHTML = '';
                }

                const subContainer = document.querySelector('.sub-optional-products-container');
                const moreProductsNumber = document.querySelector('.more-products .number');
                if (subContainer) {
                    subContainer.innerHTML = '';
                    subContainer.style.display = 'none';
                    if (moreProductsNumber) {
                        moreProductsNumber.textContent = '3';
                    }
                }

                // Décocher toutes les options
                document.querySelectorAll('.optional-product-checkbox:checked').forEach(checkbox => {
                    checkbox.checked = false;
                });

                // NEW: Clear .selected from more products
                document.querySelectorAll('.more-product-label.selected').forEach(label => label.classList.remove('selected'));

                // Vider le résumé de configuration
                const summaryContainer = document.querySelector('.configuration-summary .content');
                if (summaryContainer) {
                    summaryContainer.innerHTML = '';
                }
            });

            // Écouter aussi au chargement si une variation par défaut existe
            jQuery(document).ready(() => {
                setTimeout(() => {
                    const form = jQuery('.variations_form');
                    if (form.length) {
                        // Vérifier s'il y a une variation active par défaut
                        const variationId = form.find('input[name="variation_id"]').val();
                        if (variationId) {
                            this.searchRelatedProducts(variationId);
                        }
                    }
                }, 1000);
            });
        }
    },

    searchRelatedProducts: function (variationId) {
        // Vérifier les dépendances
        if (typeof jQuery === 'undefined') {
            return;
        }

        if (typeof window.douze_ajax === 'undefined') {
            // Fallback: créer les variables manuellement si elles ne sont pas définies
            window.douze_ajax = {
                ajax_url: '/wp-admin/admin-ajax.php',
                nonce: 'fallback_nonce'
            };
        }

        // Faire une requête AJAX pour chercher les produits liés
        jQuery.ajax({
            url: window.douze_ajax.ajax_url,
            type: 'POST',
            data: {
                action: 'search_related_products',
                variation_id: variationId,
                nonce: window.douze_ajax.nonce
            },
            success: (response) => {
                if (response.success) {
                    this.displayOptionalProducts(response.data);
                } else {
                    this.displayOptionalProducts([]);
                }
            },
            error: () => {
                // En cas d'erreur, ne rien afficher
                this.displayOptionalProducts([]);
            }
        });
    },

    displayOptionalProducts: function (products) {
        let container = document.querySelector('.optional-products-container');

        if (!products || products.length === 0) {
            if (container) {
                container.remove();
            }
            return;
        }

        if (!container) {
            container = document.createElement('div');
            container.className = 'optional-products-container config-frame';

            const variationsTable = document.querySelector('.og-variations');
            if (variationsTable) {
                variationsTable.parentNode.insertBefore(container, variationsTable.nextSibling);
            } else {
                const variationsForm = document.querySelector('.variations_form');
                if (variationsForm) {
                    variationsForm.appendChild(container);
                }
            }
        }

        // Créer ou récupérer le conteneur externe pour les SPO (juste après le conteneur principal)
        let spoContainer = document.querySelector('.sub-optional-products-container');
        if (!spoContainer) {
            spoContainer = document.createElement('div');
            spoContainer.className = 'sub-optional-products-container config-frame';
            spoContainer.style.display = 'none';
            // Insérer juste après le container des produits optionnels
            if (container.parentNode) {
                container.parentNode.insertBefore(spoContainer, container.nextSibling);
            }
        }

        // Vider le conteneur
        container.innerHTML = '';

        // Créer une table avec affichage vertical (1 PO par ligne)
        const mainAccessoriesLabel = getTranslatedString('mainAccessories', 'Accessoires principaux');
        const helpAriaLabel = getTranslatedString('helpAriaLabel', 'Aide');

        container.innerHTML = `
            <div class="config-frame-title">
                <span class="number">2</span> ${mainAccessoriesLabel}
            </div>
            <div class="variations-scroll-wrapper">
                            <div class="variations-scrollable">
            <table class="variations" cellspacing="0" role="presentation">
                <tbody>
                                ${products.map(product => {
            // Récupérer le texte d'aide du PO
            const helpText = product.help || '';
            const helpIcon = helpText ? `<a class="attribute-help-icon po-help-icon" data-help-text="${helpText.replace(/"/g, '&quot;')}" aria-label="${helpAriaLabel}">i</a>` : '';

            return `
                    <tr>
                        <td class="optional-product" data-product-id="${product.id}">
                            <label class="product-label optional-product-label attribute-image" 
                                    data-product-id="${product.id}" 
                                    data-price="${product.raw_price_ttc || 0}"
                                    data-full-bike="${product.full_bike || ''}">
                                ${helpIcon}
                                ${product.image ?
        `<img src="${product.image}" alt="${product.name.replace(/"/g, '&quot;')}" class="attribute-img">` :
        '<span class="no-image">i</span>'
    }
                                    <span class="image-label">${product.name}</span>
                                    <span class="price-label">(+${product.price})</span>
                            </label>
                        </td>
                        </tr>
                    `}).join('')}
                </tbody>
            </table>
            </div>
            </div>
            <div class="variations-nav-footer">
                <button type="button" class="variations-nav nav-left"></button>
                <button type="button" class="variations-nav nav-right"></button>
            </div>
        `;

        this.setupScrollable(container.querySelector('.variations-scrollable'));
    },

    // Nouvelle méthode pour chercher et afficher les SPO
    searchSubOptionalProducts: function (productId, container) {
        if (typeof jQuery === 'undefined') {
            return;
        }

        // Faire une requête AJAX pour chercher les SPO
        jQuery.ajax({
            url: window.douze_ajax.ajax_url,
            type: 'POST',
            data: {
                action: 'search_sub_optional_products',
                product_id: productId,
                nonce: window.douze_ajax.nonce
            },
            success: (response) => {
                if (response.success && response.data.length > 0) {
                    this.displaySubOptionalProducts(response.data, container);
                } else {
                    // Masquer le conteneur s'il n'y a pas de SPO
                    container.style.display = 'none';
                }
            },
            error: () => {
                const loadingErrorLabel = getTranslatedString('loadingError', 'Erreur de chargement');
                container.innerHTML = `<div class="spo-error" style="color: #999; font-size: 12px;">${loadingErrorLabel}</div>`;
            }
        });
    },

    // Nouvelle méthode pour afficher les SPO
    displaySubOptionalProducts: function (products, container) {
        const secondaryAccessoriesLabel = getTranslatedString('secondaryAccessories', 'Accessoires secondaires');
        const helpAriaLabel = getTranslatedString('helpAriaLabel', 'Aide');

        container.innerHTML = `
            <div class="config-frame-title">
                <span class="number">3</span> ${secondaryAccessoriesLabel}
            </div>
            <div class="variations-scroll-wrapper">
                            <div class="variations-scrollable">
            <table class="variations" cellspacing="0" role="presentation">
                <tbody>
                    
                ${products.map(product => {
            // Récupérer le texte d'aide du SPO
            const helpText = product.help || '';
            const helpIcon = helpText ? `<a class="attribute-help-icon spo-help-icon" data-help-text="${helpText.replace(/"/g, '&quot;')}" aria-label="${helpAriaLabel}">i</a>` : '';

            return `
            <tr>
                <td>
                    <label class="product-label sub-optional-product-label attribute-image" 
                           data-product-id="${product.id}" 
                           data-price="${product.raw_price_ttc || 0}">
                        ${helpIcon}
                        ${product.image ?
                    `<img src="${product.image}" alt="${product.name.replace(/"/g, '&quot;')}" class="attribute-img">` :
                    '<span class="no-image">i</span>'
                }
                        <span class="image-label">${product.name}</span>
                        <span class="price-label">(+${product.price})</span>
                    </label>
                    </td>
                    </tr>
                `}).join('')}
            </tbody>
            </table>
            </div>
            </div>
            <div class="variations-nav-footer">
                <button type="button" class="variations-nav nav-left"></button>
                <button type="button" class="variations-nav nav-right"></button>
            </div>
        `;

        container.style.display = 'block';

        const moreProductsNumber = document.querySelector('.more-products .number');
        if (moreProductsNumber) {
            moreProductsNumber.textContent = '4';
        }

        this.setupScrollable(container.querySelector('.variations-scrollable'));
    },

    initOptionalProducts: function () {
        document.addEventListener('click', (e) => {
            if (e.target.closest('.optional-product-label')) {
                e.preventDefault();

                const clickedLabel = e.target.closest('.optional-product-label');
                const allLabels = document.querySelectorAll('.optional-product-label');
                const isCurrentlySelected = clickedLabel.classList.contains('selected');
                const productRow = clickedLabel.closest('.optional-product');
                const subContainer = document.querySelector('.sub-optional-products-container');

                // Désélectionner tous les PO et masquer le conteneur SPO
                allLabels.forEach(label => {
                    label.classList.remove('selected');
                });

                if (subContainer) {
                    subContainer.style.display = 'none';
                    subContainer.innerHTML = '';
                    
                    const moreProductsNumber = document.querySelector('.more-products .number');
                    if (moreProductsNumber) {
                        moreProductsNumber.textContent = '3';
                    }
                }

                document.querySelectorAll('.sub-optional-product-label.selected').forEach(label => {
                    label.classList.remove('selected');
                });

                // Superposition de l'image full_bike
                if (!isCurrentlySelected) {
                    clickedLabel.classList.add('selected');
                    const fullBikeImage = clickedLabel.dataset.fullBike;
                    if (fullBikeImage) {
                        this.showFullBikeOverlay(fullBikeImage);
                    }

                    if (subContainer) {
                        subContainer.style.display = 'block';
                        const optionsLoadingLabel = getTranslatedString('optionsLoading', 'Chargement des options...');
                        subContainer.innerHTML = `<div class="spo-loading" style="color: #666; font-size: 12px;">${optionsLoadingLabel}</div>`;
                        this.searchSubOptionalProducts(clickedLabel.dataset.productId, subContainer);
                    }
                } else {
                    this.removeFullBikeOverlay();
                }

                this.updateVariationPrice();
                this.updateOptionalProductsField();
            }

            // Gérer la sélection MULTIPLE des SPO (comportement différent des PO)
            if (e.target.closest('.sub-optional-product-label')) {
                e.preventDefault();

                const clickedSpoLabel = e.target.closest('.sub-optional-product-label');
                const isCurrentlySelected = clickedSpoLabel.classList.contains('selected');

                // Pour les SPO : sélection/désélection individuelle (pas de désélection des autres)
                if (isCurrentlySelected) {
                    // Désélectionner ce SPO
                    clickedSpoLabel.classList.remove('selected');
                } else {
                    // Sélectionner ce SPO (sans affecter les autres)
                    clickedSpoLabel.classList.add('selected');
                }

                // Mettre à jour le prix et le champ caché APRÈS la sélection
                this.updateVariationPrice();
                this.updateOptionalProductsField();
            }

            // Gérer la sélection MULTIPLE des More Products (Accessoires compatibles)
            if (e.target.closest('.more-product-label')) {
                e.preventDefault();

                const clickedMoreLabel = e.target.closest('.more-product-label');
                const isCurrentlySelected = clickedMoreLabel.classList.contains('selected');

                if (isCurrentlySelected) {
                    clickedMoreLabel.classList.remove('selected');
                } else {
                    clickedMoreLabel.classList.add('selected');
                }

                this.updateVariationPrice();
                this.updateOptionalProductsField();
            }
        });
    },

    showFullBikeOverlay: function (imageUrl) {
        this.removeFullBikeOverlay();
        if (!imageUrl) return;
        const mainImageContainer = document.querySelector('.main-image');
        if (mainImageContainer) {
            // S'assure que le conteneur est positionné
            if (getComputedStyle(mainImageContainer).position === 'static') {
                mainImageContainer.style.position = 'relative';
            }
            const overlayImg = document.createElement('img');
            overlayImg.className = 'full-bike-overlay-image';
            overlayImg.src = imageUrl;
            overlayImg.style.position = 'absolute';
            overlayImg.style.top = '0';
            overlayImg.style.left = '0';
            overlayImg.style.width = '100%';
            overlayImg.style.height = '100%';
            overlayImg.style.pointerEvents = 'none';
            overlayImg.style.zIndex = '10';
            overlayImg.style.mixBlendMode = 'multiply'; // Optionnel, à ajuster selon le rendu souhaité
            mainImageContainer.appendChild(overlayImg);
        }
    },

    removeFullBikeOverlay: function () {
        const mainImageContainer = document.querySelector('.main-image');
        if (mainImageContainer) {
            const overlayImg = mainImageContainer.querySelector('.full-bike-overlay-image');
            if (overlayImg) {
                mainImageContainer.removeChild(overlayImg);
            }
        }
    },

    updateVariationPrice: function () {
        // Selector 1: Standard variation price (inside .title-price-buy or just standard)
        const priceElements = document.querySelectorAll('.woocommerce-variation-price .price');
        // Selector 2: Mobile bar
        const mobilePrice = document.querySelector('.woocommerce-variation-price-mobile .price');
        
        if (this.originalVariationPrice === 0) {
            return;
        }

        const optionalProductsPrice = this.getOptionalProductsPrice();
        const totalPrice = this.originalVariationPrice + optionalProductsPrice;

        // Formater le prix selon le format français
        const formattedPrice = totalPrice.toFixed(2).replace('.', ',');

        // HTML du prix formaté
        const priceHTML = `<span class="woocommerce-Price-amount amount"><bdi>${formattedPrice}&nbsp;€</bdi></span>`;

        // Remplacer partout où on trouve le prix de variation
        if (priceElements.length > 0) {
            priceElements.forEach(el => {
                el.innerHTML = priceHTML;
            });
        }
        
        // Remplacer aussi dans la barre mobile si elle existe
        if (mobilePrice) {
            mobilePrice.innerHTML = priceHTML;
        }
        
        // Remplacer aussi dans le header dupliqué si nécessaire (normalement c'est une copie de .single_variation, donc ça devrait suivre si on met à jour .single_variation avant)
        // Mais comme le header est une copie HTML à un instant T, on doit peut-être le forcer aussi
        const headerPrice = document.querySelector('.header-variation-info .woocommerce-variation-price .price');
        if (headerPrice) {
            headerPrice.innerHTML = priceHTML;
        }
    },

    getOptionalProductsPrice: function () {
        let total = 0;

        // Prix du PO sélectionné (toujours un seul)
        const selectedPo = document.querySelector('.optional-product-label.selected');
        if (selectedPo) {
            const poPrice = parseFloat(selectedPo.dataset.price) || 0;
            total += poPrice;
        }

        // Prix de TOUS les SPO sélectionnés (sélection multiple)
        const selectedSpos = document.querySelectorAll('.sub-optional-product-label.selected');
        if (selectedSpos.length > 0) {
            selectedSpos.forEach(spo => {
                const spoPrice = parseFloat(spo.dataset.price) || 0;
                total += spoPrice;
            });
        }

        // Prix de TOUS les More Products sélectionnés (sélection multiple)
        const selectedMore = document.querySelectorAll('.more-product-label.selected');
        if (selectedMore.length > 0) {
            selectedMore.forEach(mp => {
                const mpPrice = parseFloat(mp.dataset.price) || 0;
                total += mpPrice;
            });
        }

        return total;
    },

    updateOptionalProductsField: function () {
        const selectedPo = document.querySelector('.optional-product-label.selected');
        const selectedSpos = document.querySelectorAll('.sub-optional-product-label.selected');

        const selectedProducts = [];

        // Ajouter le PO sélectionné (toujours un seul)
        if (selectedPo) {
            selectedProducts.push(selectedPo.dataset.productId);
        }

        // Ajouter TOUS les SPO sélectionnés
        if (selectedSpos.length > 0) {
            selectedSpos.forEach(spo => {
                selectedProducts.push(spo.dataset.productId);
            });
        }

        const selectedMore = document.querySelectorAll('.more-product-label.selected');
        // Ajouter TOUS les More Products sélectionnés
        if (selectedMore.length > 0) {
            selectedMore.forEach(mp => {
                selectedProducts.push(mp.dataset.productId);
            });
        }

        const hiddenField = document.querySelector('.optional-products-input');
        if (hiddenField) {
            const newValue = selectedProducts.length > 0 ? JSON.stringify(selectedProducts) : '';
            hiddenField.value = newValue;
            hiddenField.setAttribute('value', newValue);
        }

        // Mettre à jour le résumé de configuration
        this.updateConfigurationSummary();
    },

    updateConfigurationSummary: function (variationId) {
        if (typeof jQuery === 'undefined' || typeof window.douze_ajax === 'undefined') return;

        // If variationId not passed, get it from form
        if (!variationId) {
            const form = jQuery('.variations_form');
            variationId = form.find('input[name="variation_id"]').val();
        }

        if (!variationId) return;

        // Get optional products
        const selectedPo = document.querySelector('.optional-product-label.selected');
        const selectedSpos = document.querySelectorAll('.sub-optional-product-label.selected');
        const selectedMore = document.querySelectorAll('.more-product-label.selected');
        
        let poId = selectedPo ? selectedPo.dataset.productId : '';
        let spoIds = [];
        selectedSpos.forEach(el => spoIds.push(el.dataset.productId));
        
        let moreIds = [];
        selectedMore.forEach(el => moreIds.push(el.dataset.productId));

        const summaryContainer = document.querySelector('.configuration-summary .content');
        if (!summaryContainer) return;

        // Show loading state
        summaryContainer.style.opacity = '0.5';

        jQuery.ajax({
            url: window.douze_ajax.ajax_url,
            type: 'POST',
            data: {
                action: 'generate_configuration_summary',
                nonce: window.douze_ajax.nonce,
                variation_id: variationId,
                po_id: poId,
                spo_ids: spoIds,
                more_ids: moreIds
            },
            success: (response) => {
                if (response.success) {
                    summaryContainer.innerHTML = response.data.summary;
                }
                summaryContainer.style.opacity = '1';
            },
            error: () => {
                summaryContainer.style.opacity = '1';
            }
        });
    },

    // Renommé et généralisé pour gérer tous les tooltips d'aide
    initHelpTooltip: function () {
        // Créer le tooltip une seule fois
        if (!document.querySelector('.attribute-help-tooltip')) {
            const tooltip = document.createElement('div');
            tooltip.className = 'attribute-help-tooltip';
            tooltip.style.display = 'none';
            document.body.appendChild(tooltip);
        }

        // Gérer le click sur TOUTE icône d'aide (attributs, PO, SPO)
        document.addEventListener('click', (e) => {
            const helpIcon = e.target.closest('.attribute-help-icon');

            if (helpIcon) {
                e.preventDefault();
                e.stopPropagation();

                const tooltip = document.querySelector('.attribute-help-tooltip');
                const helpText = helpIcon.dataset.helpText;

                // Si le tooltip est déjà visible pour cette icône, le masquer
                if (tooltip.classList.contains('visible') && tooltip.dataset.currentIcon === helpText) {
                    tooltip.classList.remove('visible');
                    tooltip.style.display = 'none';
                    return;
                }

                // Afficher le tooltip
                tooltip.innerHTML = helpText;
                tooltip.dataset.currentIcon = helpText;

                // Positionner le tooltip près de l'icône
                const iconRect = helpIcon.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

                tooltip.style.display = 'block';
                tooltip.style.left = (iconRect.left + scrollLeft + iconRect.width / 2) + 'px';
                tooltip.style.top = (iconRect.bottom + scrollTop + 8) + 'px';

                // Ajouter la classe visible avec un petit délai pour l'animation
                setTimeout(() => {
                    tooltip.classList.add('visible');
                }, 10);
            } else {
                // Clic en dehors : masquer le tooltip
                const tooltip = document.querySelector('.attribute-help-tooltip');
                if (tooltip && tooltip.classList.contains('visible')) {
                    tooltip.classList.remove('visible');
                    setTimeout(() => {
                        tooltip.style.display = 'none';
                    }, 200);
                }
            }
        });

        // Masquer le tooltip au scroll
        window.addEventListener('scroll', () => {
            const tooltip = document.querySelector('.attribute-help-tooltip');
            if (tooltip && tooltip.classList.contains('visible')) {
                tooltip.classList.remove('visible');
                setTimeout(() => {
                    tooltip.style.display = 'none';
                }, 200);
            }
        });
    },

    initMobileDescriptionToggle: function () {
        const descriptions = document.querySelectorAll('.product.douze-configurable .woocommerce-product-details__full-description');

        if (!descriptions.length) {
            return;
        }

        const mobileQuery = window.matchMedia('(max-width: 1023px)');

        const getCollapsedHeight = (content) => {
            const styles = window.getComputedStyle(content);
            const fontSize = parseFloat(styles.fontSize) || 16;
            const parsedLineHeight = parseFloat(styles.lineHeight);
            const lineHeight = Number.isNaN(parsedLineHeight) ? fontSize * 1.4 : parsedLineHeight;

            return Math.round(lineHeight * 3);
        };

        const setToggleState = (toggle, expanded) => {
            toggle.textContent = expanded
                ? getTranslatedString('showLess', 'Voir moins')
                : getTranslatedString('showMore', 'Voir plus');
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        };

        const updateDescription = (description) => {
            const content = description.querySelector('.woocommerce-product-details__full-description-content');
            const toggle = description.querySelector('.woocommerce-product-details__toggle');

            if (!content || !toggle) {
                return;
            }

            const collapsedHeight = getCollapsedHeight(content);
            const fullHeight = content.scrollHeight;
            const isCollapsible = mobileQuery.matches && fullHeight > collapsedHeight + 8;
            const isExpanded = description.classList.contains('is-expanded');

            description.classList.toggle('is-collapsible', isCollapsible);
            toggle.hidden = !isCollapsible;

            if (!isCollapsible) {
                description.classList.remove('is-expanded');
                content.style.maxHeight = '';
                setToggleState(toggle, false);
                return;
            }

            if (isExpanded) {
                content.style.maxHeight = `${fullHeight}px`;
                setToggleState(toggle, true);
                return;
            }

            content.style.maxHeight = `${collapsedHeight}px`;
            setToggleState(toggle, false);
        };

        descriptions.forEach((description) => {
            const content = description.querySelector('.woocommerce-product-details__full-description-content');
            const toggle = description.querySelector('.woocommerce-product-details__toggle');

            if (!content || !toggle) {
                return;
            }

            if (!toggle.dataset.toggleReady) {
                toggle.dataset.toggleReady = 'true';
                toggle.addEventListener('click', () => {
                    const collapsedHeight = getCollapsedHeight(content);
                    const expanded = description.classList.contains('is-expanded');

                    if (expanded) {
                        content.style.maxHeight = `${content.scrollHeight}px`;
                        description.classList.remove('is-expanded');

                        requestAnimationFrame(() => {
                            content.style.maxHeight = `${collapsedHeight}px`;
                            setToggleState(toggle, false);
                        });

                        return;
                    }

                    content.style.maxHeight = `${collapsedHeight}px`;
                    description.classList.add('is-expanded');

                    requestAnimationFrame(() => {
                        content.style.maxHeight = `${content.scrollHeight}px`;
                        setToggleState(toggle, true);
                    });
                });
            }

            updateDescription(description);

            if ('ResizeObserver' in window && !description.dataset.resizeObserved) {
                description.dataset.resizeObserved = 'true';
                const resizeObserver = new ResizeObserver(() => {
                    updateDescription(description);
                });
                resizeObserver.observe(content);
            }
        });

        const refreshDescriptions = () => {
            descriptions.forEach((description) => {
                updateDescription(description);
            });
        };

        if (typeof mobileQuery.addEventListener === 'function') {
            mobileQuery.addEventListener('change', refreshDescriptions);
        } else if (typeof mobileQuery.addListener === 'function') {
            mobileQuery.addListener(refreshDescriptions);
        }

        window.addEventListener('resize', refreshDescriptions);
    }
};

export { wcSingleProduct };
